import React, { useState, useEffect } from 'react';
import { Age } from '../Icons/CustomIcons';
import { Slider } from './Slider';
import { IconHeader } from './Dialog';
import { Input } from './Input';

/**
 * AgeRange – Altersbereich-Auswahl mit Slider und Texteingaben.
 *
 * Props:
 *   minValue      – aktueller Mindestalter-Wert
 *   maxValue      – aktueller Höchstalter-Wert
 *   onChange(min, max) – Callback mit neuen Werten
 *   fieldInfo     – optionaler Hilfetext für das FieldInfo-Icon
 *
 * Verwendung Filter:
 *   <AgeRange
 *     minValue={filters.age_min}
 *     maxValue={filters.age_max}
 *     onChange={(min, max) => { updateFilter('age_min', min); updateFilter('age_max', max); }}
 *   />
 *
 * Verwendung Formular:
 *   <AgeRange
 *     minValue={formData.ageMin}
 *     maxValue={formData.ageMax}
 *     onChange={(min, max) => setFormData(prev => ({ ...prev, ageMin: min, ageMax: max }))}
 *     fieldInfo={info.ageRange}
 *   />
 */
const AgeRange = ({ minValue, maxValue, onChange, fieldInfo = '' }) => {
  const [minInput, setMinInput] = useState(String(minValue));
  const [maxInput, setMaxInput] = useState(String(maxValue));

  useEffect(() => { setMinInput(String(minValue)); }, [minValue]);
  useEffect(() => { setMaxInput(String(maxValue)); }, [maxValue]);

  const commitMin = () => {
    const val = parseInt(minInput);
    if (!isNaN(val) && val >= 0 && val <= maxValue) {
      onChange(val, maxValue);
    } else {
      setMinInput(String(minValue));
    }
  };

  const commitMax = () => {
    const val = parseInt(maxInput);
    if (!isNaN(val) && val >= minValue && val <= 12) {
      onChange(minValue, val);
    } else {
      setMaxInput(String(maxValue));
    }
  };

  return (
    <div className="filter">      
      <IconHeader Icon={<Age size={20} color="#fff" />} info={fieldInfo}>
        Altersbereich
      </IconHeader>
      <div className="filter__box">
        <Slider
          value={[minValue, maxValue]}
          onValueChange={([min, max]) => {
            onChange(min, max);
          }}
          min={0}
          max={12}
          step={1}
          className="w-full"
        />
        <div className="age-filter__labels">
          <span className="age-filter__label">{minValue} Jahre</span>
          <span className="age-filter__label">{maxValue} Jahre</span>
        </div>
        <div className="age-filter__input">
          <span>Von</span>
          <Input
            type="number"
            className="text__input"
            value={minInput}
            min={0}
            max={maxValue}
            onChange={(e) => setMinInput(e.target.value)}
            onBlur={commitMin}
          />
          <span>bis</span>
          <Input
            type="number"
            className="text__input"
            value={maxInput}
            min={minValue}
            max={12}
            onChange={(e) => setMaxInput(e.target.value)}
            onBlur={commitMax}
          />
        </div>
      </div>
    </div>
  );
};

export default AgeRange;
